import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastService } from 'src/app/shared/services/toast.service';
import { AppInitService } from '../../app-init.service';
import { AppConfigurations } from '../models/appConfiguration.model';

@Injectable({
  providedIn: 'root'
})
export class BulkDataOpsService {
  private appConfig?: AppConfigurations;
  public exportControllerUrl : string = '';

  constructor(private http : HttpClient, private appInitService: AppInitService, private toastService: ToastService) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onRecieveAppConfig(config)
    });
   }

   private _onRecieveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.exportControllerUrl = `${this.appConfig.bulkDataOpsApi.baseApiUrl}${this.appConfig.bulkDataOpsApi.exportDataController}`;
  }


  exportToCSV(id: number): Observable<{ blob: Blob; filename: string }> {
    const url = `${this.exportControllerUrl}/${id}`;
    return this.http.get(url, { responseType: 'blob', observe: 'response' }).pipe(
      
      map(response => {   
            // Extract the filename from the Content-Disposition header
            const contentDisposition = response.headers.get('Content-Disposition');
            const contentDispositionHeaderResult = contentDisposition?.split(';')[1].trim().split('=')[1];
            const filenameMatch = contentDispositionHeaderResult?.replace(/"/g, '');
            const filename = filenameMatch ? filenameMatch : 'exported.csv';

            if (!response.body) {
              throw new Error(`${filename} export failed!`);
            }
            const blob = new Blob([response.body], { type: 'application/csv' });
            return { blob, filename };

        
      })
    );
  }
}
